import { useMediaQuery } from "@mui/material";
import "../../styles/TestimonialsSection/TestimonialsHeader.scss";
import { useTranslation } from "react-i18next";

export const TestimonialsHeader = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:800px)");
  return (
    <div className="TestimonialsHeader">
      <h2 style={{ width: isMobile ? "70%" : "100%" }}>
        {t("testimonials_header")}
      </h2>
      <img
        src="/images/reviews.svg"
        alt="reviews"
        style={{ alignSelf: isMobile ? "center" : "start" }}
        width={!isMobile ? "40rem" : "30rem"}
        height={!isMobile ? "40rem" : "30rem"}
      />
    </div>
  );
};
